import { type TableView } from 'owa-mail-list-store';
import { mutatorAction } from 'satcheljs';

export const setCurrentLoadedIndexMutator: (tableView: TableView) => void = mutatorAction(
    'setCurrentLoadedIndex',
    (tableView: TableView): void => {
        tableView.currentLoadedIndex = tableView.rowKeys.length;
    }
);
